import { req } from "@/api/api_request";

// 获取无人船船视频流
export function getBoardVideo(board_id) {
  let url = `board/get-board-video?board_id=${board_id}`;
  return req.get(url);
}
